import { useEffect, useState } from 'react'
import GetUrls from 'ts/enums/Url'
import { Department } from 'ts/types'
import useModalStore from 'store/modal'
import { Input, CheckBoxToggle } from 'components/ui'
import useModalForm from 'hooks/useModalForm'


const DepartmentAddPage = () => {
const Url = GetUrls();

  const params = useModalStore((state) => state.params) as Department
  const { ModalForm, form } = useModalForm()
  const { setValue, register } = form
  const [isActive, setIsActive] = useState<boolean>(true);

  const handleToggleActive = (isChecked: boolean) => {
    setIsActive(isChecked);
  }

  useEffect(() => {
    if (params) {
      setValue('departmentId', params.departmentId)
      setIsActive(params.isActive);
    }
  }, [params, setValue])

  return (
    <ModalForm
    config={{ url: params ? Url.updateDepartment : Url.postDepartment, method: params ? 'PUT' : 'POST' }}
      title={`${params ? 'Edit ' : 'Create ' }Department`}
      description='Create or edit a department'
    >
      <CheckBoxToggle 
        label="Active" 
        defaultChecked={isActive} 
        onToggle={handleToggleActive}
      />
      {params ? (
        <Input defaultValue={params.departmentId} label="ID" disabled />
      ) : null}
      <Input
          label="Active" 
          className='hidden'
          {...register("isActive", { value : isActive ? 1 : 0 })}
      />
      <Input
        defaultValue={params?.departmentName}
        label="Department Name"
        {...register('departmentName', { required: true })}
      />
    </ModalForm>
  )
}

export default DepartmentAddPage
